import React from "react"
import { useModal } from "utils/context/ModalContext"
import FailModal from "./FailModal"
import LoadingModal from "./LoadingModal"
import SuccessModal from "./SuccessModal"
import ConfirmationModal from "./ConfirmationModal"

const GlobalModals = () => {
    const {
        failModal,
        loading,
        successModal,
        hideFail,
        hideLoading,
        hideSuccess,
        confirmationModal,
        handleConfirm,
        handleCancel
    } = useModal()

    return (
        <>
            {failModal?.isOpen && (
                <FailModal
                    onClose={hideFail}
                    data={failModal?.data}
                    message={failModal?.message}
                />
            )}

            {loading?.isOpen && (
                <LoadingModal
                    onClose={hideLoading}
                />
            )}

            {successModal?.isOpen && (
                <SuccessModal
                    onClose={hideSuccess}
                    data={successModal?.data}
                />
            )}

            {confirmationModal?.isOpen && (
                <ConfirmationModal
                    message={confirmationModal?.message}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                />
            )}
        </>
    )
}

export default GlobalModals